import styled from 'styled-components';

export const StyledLegendContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const StyledView = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
